
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lms-connect",
      function () {
        return require("private-next-pages/lms-connect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lms-connect"])
      });
    }
  